import React from 'react';

import { locale } from '@trqk/utils';

import { Tooltip, IconInfoCircle, IconX } from '../..';
import { getSmallValuesMessage } from '../helpers';

/**
 * @typedef {ChartInfoTooltipProps}
 * @property {number} maxSize the maximum length of the rendered data array
 * @property {number} minValue the minimum value that is shown in the rendered data array
 */
interface ChartInfoTooltipProps {
    maxSize: number;
    minValue: number;
}

/**
 * Renders an `<IconInfoCircle />` that triggers a `<Tooltip />` explaining how data is filtered and
 * sliced; i.e.:
 * - only the top x values are shown
 * - values smaller than y are not shown
 * @param {ChartInfoTooltipProps} props
 */
export const ChartInfoTooltip = ({
    maxSize,
    minValue,
}: ChartInfoTooltipProps): JSX.Element => (
    <Tooltip
        background="light"
        RenderMessage={({ close }: RenderTooltipMessageProps): JSX.Element => (
            <div className="text-tertiary-500 bg-white pb-4">
                <div className="flex justify-end px-2 pt-2 pb-3">
                    <IconX
                        width={12}
                        fillColor="tertiary-400"
                        handleClick={close}
                    />
                </div>
                <ul className="list-disc ml-6 text-tertiary-400 italic">
                    <li className="mb-1">
                        {`${locale.enUS.STATEMENTS.INFO.TOP_VALUES_SHOWN.PART_1} ${maxSize} ${locale.enUS.STATEMENTS.INFO.TOP_VALUES_SHOWN.PART_2}`}
                    </li>
                    <li>{getSmallValuesMessage(minValue)}</li>
                </ul>
            </div>
        )}
        position="left"
    >
        <IconInfoCircle fillColor="tertiary-400" width={20} />
    </Tooltip>
);
